import { StyledSpinner } from './styles'

export function Spinner({ size = 32 }) {
  return <StyledSpinner size={size} />
}
